angular.module('contabilidad.polizas')
  .service('ContabilidadPolizasProvisionnominaconpagosSucursales', ContabilidadPolizasProvisionnominaconpagosSucursales)

ContabilidadPolizasProvisionnominaconpagosSucursales.$inject = ['$http', '$filter']

function ContabilidadPolizasProvisionnominaconpagosSucursales ($http, $filter) {
  this.get = _get
  this.codificar = _codificar

  function _get (nominas) {
    return $http.get('/api/nominas/polizas/provisionnominaconpagossucursales', {
      params: {nominas: nominas},
      schema: schema,
    })
  }

  var verificarCadena = $filter('rPad')

  function _codificar (data, inicio_poliza) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    3      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',
      fecha_inicio = new Date(),
      fechaA = $filter('date')(fecha_inicio, 'yyyyMMdd'),
      fechaB = $filter('date')(fecha_inicio, 'dd/MM/yyyy'),
      vuelta = 0,
      posicion

    try {
      data.cuentascontables.forEach(function (item) {
        item.importe = 0
      })
      data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          posicion = data.cuentascontables.findIndex(function (cuenta) {
            return (cuenta.cuentacontable + cuenta.concepto) === (item.cuentacontable + item.concepto)
          })
          if (posicion != -1) {
            data.cuentascontables[posicion].importe += parseFloat(item.importe)
          }

          fechaA = $filter('date')(nomina.fecha_nomina, 'yyyyMMdd')
        })
      })

      data.provision.forEach(function (nomina) {
        nomina.datos.forEach(function (item) {
          if (vuelta === 0) {
            // fechaA = $filter("date")(empleado.fecha_nomina, "yyyyMMdd"),
            cadenaPrincipal += cadA
              .replace('AAAAMMDD', fechaA)
              .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', verificarCadena('Provision Nomina' + ' ' + item.id_nomina, 60))
          }

          fechaB = verificarCadena(item.id_nomina, 15)
          if (Number.isFinite(item.importe) && item.importe !== 0) {
            cadenaPrincipal += cadB
              .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.cuentacontable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', fechaB)
              .replace('*', item.naturaleza === 'C' ? 0 : 1)
              .replace('YYYYYYYYY', verificarCadena((parseFloat(item.importe).toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.concepto), 43))
          }

          vuelta++
        })
      })

      data.pagos.forEach(function (item) {

        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable.replace(/-/g, ''), 16))
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 1)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        if (item.Importe_Complementario > 0) {
          cadenaPrincipal += cadB
            .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Complementaria.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
            .replace('*', 1)
            .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Importe_Complementario).toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena(('Pago de Nomina'), 43))
        }
        cadenaPrincipal += cadB
          .replace('CCCCCCCCCCCCCCCC', verificarCadena(item.Cuenta_Contable_Banco.replace(/-/g, '')), 16)
          .replace('ZZZZZZZZZZZZZZZ', verificarCadena(item.Fecha, 15))
          .replace('*', 0)
          .replace('YYYYYYYYY', verificarCadena((parseFloat(item.Pago).toFixed(2)), 9))
          .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', verificarCadena((item.Descripcion), 43))
      })
      return cadenaPrincipal

    } catch (err) { // try
      return 'Error'
    }

  }

  var schema = {
    provision: {datos: {importe: 'number'}},
    pagos: {Importe: 'number', Importe_Complementario: 'number'},
    cuentascontables: {importe: 'number'},
    poliza: 'number',
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/ContabilidadPolizasProvisionnominaconpagosSucursales.js